export function productTypeStringFormatting(productType: string[]) {
    return productType.map((item) =>
        item.replaceAll("-", " - ").replace("C", "°C")
    );
}

export function productTypeStringDeFormatting(productType: string[]) {
    return productType.map((item) =>
        item.replaceAll(" - ", "-").replace("°C", "C")
    );
}

export function productTypeWidgetFormatting(productType: string | undefined) {
    if (!productType) {
        return;
    }
    return productType!.replaceAll("-", " - ").replace("C", "°C");
}

export function productTempFormatting(productTemp: string) {
    return productTemp!.replaceAll("C", "").replaceAll("°", "°C ");
}
